import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { ModalConfig } from '../modal-config';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from 'ngx-clipboard';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-api-key-modal',
  standalone: true,
  imports: [
    ButtonModule,
    DividerModule,
    DialogModule,
    AvatarModule,
    TranslateModule,
    CommonModule,
    ClipboardModule,
    TooltipModule,
  ],
  templateUrl: './api-key-modal.component.html',
  styleUrls: ['./api-key-modal.component.scss'],
})
export class ApiKeyModalComponent {
  @Input()
  config: ModalConfig;
  @Output()
  closeDialog: EventEmitter<void> = new EventEmitter<void>();
  showTooltip: boolean = false;

  constructor() {}

 

  // Méthode pour afficher le tooltip manuellement
  toggleTooltip() {
    this.showTooltip = !this.showTooltip;
  }

  handleClose() {
    this.closeDialog.emit();
  }
}
